module.exports = __webpack_public_path__ + "img/faroe-islands.fd474191.svg";